/**
 * @file useMessagePopup.js
 * @description 全局顶部提示弹窗（success / error / login-required）
 * @module features/message/composables/useMessagePopup
 */

import { computed, watch } from 'vue'

/**
 * @param {{ message: string, type: string, duration: number, visible: boolean }} props
 * @param {(event: 'update:visible', value: boolean) => void} emit
 */
export function useMessagePopup(props, emit) {
  const isSuccess = computed(() => props.type === 'success')
  const isError = computed(() => props.type === 'error')
  const isLoginRequired = computed(() => props.type === 'login-required')

  watch(
    () => props.visible,
    (val) => {
      if (val) {
        setTimeout(() => {
          emit('update:visible', false)
        }, props.duration)
      }
    },
    { immediate: true }
  )

  return {
    isSuccess,
    isError,
    isLoginRequired,
  }
}
